const r = {
  mobile: {
    up: '@media (min-width: 425px)',
    down: '@media (max-width: 425px)',
    gutter: '16px',
  },
  tablet: {
    up: '@media (min-width: 768px)',
    down: '@media (max-width: 768px)',
    gutter: '16px',
  },
  desktop: { up: '@media (min-width: 1024px)', gutter: '24px' },
};

const theme = {
  typography: {
    fontFamily: 'Nunito, sans-serif',
  },
  colors: {
    primary: '#5856D6',
    secondary: '#fe5f3a',
    error: '#f44336',
    title: '#282C37',
    bodyText: '#282C37',
    bodyTextLight: '#6D819C',
    background: '#f8faff',
    anchor: '#5651d9',
    border: 'rgba(0,0,0, 0.1)',
    lightBorder: '#eee',
  },
  shadow: {
    box:
      'rgba(0, 0, 0, 0.05) 0px 1px 3px 0px, rgba(0, 0, 0, 0.024) 0px 1px 1px 0px',
    level0: 'rgba(0, 0, 0, 0.12) 0px 5px 15px 0px',
    level1: 'rgba(0, 0, 0, 0.12) 0px 5px 20px 0px',
    level2: 'rgba(0, 0, 0, 0.20) 0px 5px 25px 0px',
  },
  r,
  helpers: {
    gutter: {
      [r.desktop.up]: {
        padding: r.desktop.gutter,
      },
      [r.tablet.up]: {
        padding: r.tablet.gutter,
      },
      padding: r.mobile.gutter,
    },
  },
};

export type Theme = typeof theme;

export default theme;
